"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = lastTyping;

var _simpleUpdateIn = _interopRequireDefault(require("simple-update-in"));

var _incomingActivity = require("../actions/incomingActivity");

var _postActivity = require("../actions/postActivity");

/*eslint no-case-declarations: "off"*/

/*eslint no-unused-vars: "off"*/
var DEFAULT_STATE = {};

function lastTyping() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      payload = _ref.payload,
      type = _ref.type;

  if (type === _incomingActivity.INCOMING_ACTIVITY || type === _postActivity.POST_ACTIVITY_PENDING) {
    var _payload$activity = payload.activity,
        _payload$activity$fro = _payload$activity.from,
        id = _payload$activity$fro.id,
        name = _payload$activity$fro.name,
        role = _payload$activity$fro.role,
        activityType = _payload$activity.type;

    if (activityType === 'typing') {
      state = (0, _simpleUpdateIn["default"])(state, [id], function () {
        return {
          at: Date.now(),
          name: name,
          role: role
        };
      });
    } else if (activityType === 'message') {
      state = (0, _simpleUpdateIn["default"])(state, [id]);
    }
  }

  return state;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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